import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryText, label, mention, white } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	callForwardingInput: {
		width: 270,
	},
	contactSupport: {
		paddingLeft: 40,
	},
	supportLink: {
		color: brandPrimaryText,
		textDecoration: 'none',
	},
	container: {},
	enableForwardingContainer: {
		alignItems: 'center',
		display: 'flex',
	},
	fieldErrorContainer: {
		marginLeft: 20,
	},
	textSignatureDisclosureInput: {
		height: 124,
		padding: 14,
		paddingTop: 10,
		maxHeight: '50vh',
		minHeight: 124,
		maxWidth: 600,
		resize: 'vertical',
		backgroundColor: white,
	},
	hostedMessage: {
		backgroundColor: mention,
		borderLeft: `3px solid ${brandPrimary}`,
		borderRadius: 4,
		color: label,
		lineHeight: 1.8,
		padding: '12px 16px',
	},
	marginBottom: {
		marginBottom: 10,
	},
	sections: {
		fontSize: 14,
		...CssSelectors.allChildren(
			{
				marginTop: 28,
			},
			':not(:first-child)'
		),
	},
});
